import axios from 'axios';
import authHeader from "@/service/auth-header";

class ProvisionComponentService {

    async getProvisionComponentsForProvision(provisionId) {
        console.log("[ProvisionComponentService][getProvisionComponentsForProvision] Before making Rest call. ID = ", provisionId);

        return await axios.get(`/api/provisioncomponent/provision/${provisionId}`,{ headers: authHeader() })
    }

    async createProvisionComponent(provisionId, data) {
        console.log("[ProvisionComponentService][createProvisionComponent] Before making Rest call. Data = ", data);

        return await axios.post(`/api/provisioncomponent/${provisionId}`, data,{ headers: authHeader() });
    }

    async updateProvisionComponent(provisionComponentId, data) {
        return await axios.put(`/api/provisioncomponent/${provisionComponentId}`, data,{ headers: authHeader() });
    }

    async deleteProvisionComponent(provisionComponentId) {
        return await axios.delete(`/api/provisioncomponent/${provisionComponentId}`,{ headers: authHeader() })
    }
}

export default new ProvisionComponentService();
